import { useState, useMemo } from "react";
import type { Municipality } from "@/mocks/configuracoes";
import SettingsStatusBadge from "./SettingsStatusBadge";

interface MunicipalitiesTableProps {
  municipalities: Municipality[];
}

export default function MunicipalitiesTable({ municipalities }: MunicipalitiesTableProps) {
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    return municipalities.filter((m) => {
      if (search) {
        const q = search.toLowerCase();
        if (!m.name.toLowerCase().includes(q) && !m.ibgeCode.includes(q)) return false;
      }
      return true;
    });
  }, [municipalities, search]);

  return (
    <div className="space-y-4">
      <div className="relative max-w-sm">
        <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm" />
        <input type="text" placeholder="Buscar município..." value={search} onChange={(e) => setSearch(e.target.value)} className="w-full pl-9 pr-4 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-900 focus:ring-2 focus:ring-primary-200 focus:border-primary-500 outline-none" />
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-background-200">
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Município</th>
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">UF</th>
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Código IBGE</th>
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">SRID padrão</th>
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Limite disponível</th>
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Projetos ativos</th>
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Status</th>
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Ações</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((m) => (
              <tr key={m.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="py-2.5 px-3 text-foreground-900 font-medium">{m.name}</td>
                <td className="py-2.5 px-3 text-foreground-600 text-xs">{m.state}</td>
                <td className="py-2.5 px-3 text-foreground-500 text-xs font-mono">{m.ibgeCode}</td>
                <td className="py-2.5 px-3 text-foreground-500 text-xs font-mono">{m.defaultSrid}</td>
                <td className="py-2.5 px-3">
                  {m.hasBoundary
                    ? <span className="inline-flex items-center gap-1 text-xs text-primary-600"><i className="ri-check-line" /> Disponível</span>
                    : <span className="inline-flex items-center gap-1 text-xs text-foreground-400"><i className="ri-close-line" /> Não disponível</span>
                  }
                </td>
                <td className="py-2.5 px-3">
                  <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-accent-50 text-accent-700 text-xs font-semibold">{m.activeProjects}</span>
                </td>
                <td className="py-2.5 px-3"><SettingsStatusBadge status={m.status} /></td>
                <td className="py-2.5 px-3">
                  <button className="w-8 h-8 rounded-lg hover:bg-background-100 flex items-center justify-center text-foreground-400 hover:text-primary-600 transition-colors" title="Editar">
                    <i className="ri-edit-line text-sm" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}